import { Button, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

interface NoFeatureAccessProps {
  orgName: string;
  // 'org': the org has no dashboard features enabled; 'user': the member has none granted.
  reason: 'org' | 'user';
}

// Shown in place of a redirect back to the org list, which looked like the org click did nothing.
export function NoFeatureAccess({ orgName, reason }: NoFeatureAccessProps) {
  const navigate = useNavigate();
  return (
    <VStack data-testid="no-feature-access" spacing={4} py={16} textAlign="center">
      <Text fontSize="xl" fontWeight="semibold">No dashboard access</Text>
      <Text color="gray.600" maxW="md">
        {reason === 'org'
          ? `No dashboard features are enabled for ${orgName}. Contact TaskEye support to enable them.`
          : `You don't have access to any features in ${orgName}. Ask your organization admin to grant you access.`}
      </Text>
      <Button variant="outline" data-testid="no-feature-access-choose-org" onClick={() => navigate('/client/orgs')}>
        Choose another organization
      </Button>
    </VStack>
  );
}
